<template>
  <div class="check-list">
    <div class="second-title">
      {{ title }}
    </div>
    <el-checkbox
      v-if="hasAll"
      v-model="checkAll"
      :indeterminate="isIndeterminate"
      @change="handleAll"
    >
      全选
    </el-checkbox>
    <el-checkbox-group v-model="tempCheck" @change="handleCheck">
      <el-checkbox
        v-for="city in options"
        :key="city.value"
        :label="city.value"
      >
        {{ city.label }}
      </el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: null,
    },
    hasAll: {
      type: Boolean,
      default: true,
    },
    checked: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      checkAll: false,
      isIndeterminate: false,
      tempCheck: [],
    };
  },
  computed: {
    isCheckInfo() {
      const { checked, options } = this;
      return { checked, options };
    },
  },
  watch: {
    isCheckInfo: {
      handler(val) {
        const { checked, options } = val;
        this.tempCheck = checked;
        this.checkAll = checked.length === options.length;
        this.isIndeterminate = !!(checked.length > 0 && checked.length < options.length);
      },
      immediate: true,
    },
  },
  methods: {
    handleAll(val) {
      this.tempCheck = val ? this.options.map((t) => t.value) : [];
      this.isIndeterminate = false;
      this.$emit('handleCheck', this.tempCheck);
    },
    handleCheck(value) {
      const checkedCount = value.length;
      this.checkAll = checkedCount === this.options.length;
      this.isIndeterminate = !!(checkedCount > 0 && checkedCount < this.options.length);
      this.$emit('handleCheck', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.check-list{
  margin-bottom: 30px;
  .second-title{
    margin-bottom:8px;
  }
  ::v-deep .el-checkbox{
    margin:0 32px 8px 0;
    color:#404B5C;
  }
}
</style>
